/**
 * OhMy USP-Karten (mobil): Geöffnete Karte überlagert die gesamte Komponente.
 * FLIP-Animation: Die Karte wächst von ihrer Kachel-Position zur vollen Grid-Fläche —
 * links oben öffnet nach unten rechts, rechts oben nach unten links (ergibt sich
 * automatisch aus Start- und Zielposition). Ein Platzhalter hält die Lücke im Raster.
 */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 380;

  function setToggleState(card, open) {
    var btn = card.querySelector('[data-usp-toggle]');
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }

  function openCard(card, grid) {
    var gridRect = grid.getBoundingClientRect();
    var rect = card.getBoundingClientRect();

    // Platzhalter hält die Kachel-Lücke, während die Karte absolut wird
    var ph = document.createElement('div');
    ph.className = 'ohmy-usp__placeholder';
    ph.style.height = rect.height + 'px';
    card.after(ph);
    grid._placeholder = ph;

    card.style.position = 'absolute';
    card.style.top = (rect.top - gridRect.top) + 'px';
    card.style.left = (rect.left - gridRect.left) + 'px';
    card.style.width = rect.width + 'px';
    card.style.minHeight = rect.height + 'px';

    card.classList.add('is-open');
    setToggleState(card, true);

    var run = function () {
      card.style.top = '0px';
      card.style.left = '0px';
      card.style.width = gridRect.width + 'px';
      card.style.minHeight = gridRect.height + 'px';
      // Falls der Text mehr Platz braucht als das Grid hoch ist: Grid mitwachsen lassen
      requestAnimationFrame(function () {
        var needed = card.scrollHeight;
        if (needed > gridRect.height) {
          card.style.minHeight = needed + 'px';
          grid.style.minHeight = needed + 'px';
        }
      });
    };

    if (reducedMotion) {
      run();
    } else {
      card.getBoundingClientRect(); // Reflow für Transition-Start
      card.classList.add('is-animating');
      requestAnimationFrame(run);
    }
  }

  function closeCard(card, grid) {
    var ph = grid._placeholder;
    var gridRect = grid.getBoundingClientRect();

    var finish = function () {
      card.classList.remove('is-animating', 'is-open');
      card.style.position = '';
      card.style.top = '';
      card.style.left = '';
      card.style.width = '';
      card.style.minHeight = '';
      grid.style.minHeight = '';
      if (ph) ph.remove();
      grid._placeholder = null;
    };

    card.classList.remove('is-open');
    setToggleState(card, false);

    if (reducedMotion || !ph) {
      finish();
      return;
    }

    var phRect = ph.getBoundingClientRect();
    card.style.top = (phRect.top - gridRect.top) + 'px';
    card.style.left = (phRect.left - gridRect.left) + 'px';
    card.style.width = phRect.width + 'px';
    card.style.minHeight = phRect.height + 'px';
    setTimeout(finish, DURATION);
  }

  document.querySelectorAll('[data-ohmy-usp]').forEach(function (grid) {
    grid.addEventListener('click', function (e) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      if (e.target.closest('a')) return;
      var card = e.target.closest('.ohmy-usp__card');
      if (!card || !grid.contains(card)) return;

      var openNow = grid.querySelector('.ohmy-usp__card.is-open');
      if (openNow) {
        closeCard(openNow, grid);
        return; // Overlay deckt alles ab — jeder Tap schließt zuerst
      }
      openCard(card, grid);
    });
  });

  // Bei Resize (z. B. Rotation) offene Karte sauber schließen
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-ohmy-usp]').forEach(function (grid) {
      var open = grid.querySelector('.ohmy-usp__card.is-open');
      if (open) closeCard(open, grid);
    });
  });
})();
